import { GPT_NETWORK_ID } from '../constants/config';
import { LANG } from '~/constants/config';
import { localStore } from '~/modules/common/utils/localStorageUtils';
import { generateUniqueId } from '~/composables/utils';
const { SHA256 } = require('jscrypto/SHA256');

export const createGPTSlot = (adUnitData, divId, targetings) => {
  const googletag = window.googletag;
  let slot;
  if (adUnitData?.i18n?.[LANG]) {
    adUnitData = { ...adUnitData, ...adUnitData?.i18n?.[LANG] };
  }
  if (adUnitData.isOutOfPage) {
    slot = googletag.defineOutOfPageSlot(`/${GPT_NETWORK_ID}/${adUnitData.name}`, divId);
  } else {
    slot = googletag.defineSlot(`/${GPT_NETWORK_ID}/${adUnitData.name}`, adUnitData.sizes, divId);
  }
  if (adUnitData.collapse === false) {
    slot.setCollapseEmptyDiv(false);
  }
  slot.addService(googletag.pubads());
  // Set targeting for ad unit individiaully
  Object.keys(targetings).forEach((key) => {
    slot.setTargeting(key, targetings[key]);
  });
  googletag.pubads().set('document_language', LANG);
  googletag.display(divId); // GPT: initialize adunit
  return slot;
};

export const callPrebid = (slot) => {
  const googletag = window.googletag;
  const pbjs = window.pbjs;

  return new Promise((resolve) => {
    googletag.cmd.push(function () {
      pbjs.que.push(function () {
        pbjs.requestBids({
          timeout: window.PREBID_TIMEOUT,
          adUnitCodes: [slot.getAdUnitPath()],
          bidsBackHandler() {
            pbjs.setPAAPIConfigForGPT();
            pbjs.setTargetingForGPTAsync([slot.getAdUnitPath()]);
            googletag.pubads().refresh([slot]);
            resolve();
          },
        });
      });
    });
  });
};

export const callCriteo = (slot) => {
  const googletag = window.googletag;
  return new Promise((resolve) => {
    googletag.cmd.push(function () {
      window.Criteo.events.push(function () {
        window.Criteo.RequestBidsOnGoogleTagSlots(
          {
            networkId: 6807,
            placements: [slot],
            callback() {
              window.Criteo.SetDFPKeyValueTargeting(); // Set targeting keywords
              googletag.pubads().refresh([slot]); // GPT: Call refresh() adserver to fetch the new adunits,
              resolve();
            },
          },
          1000
        );
      });
    });
  });
};

export const createPrebidAdUnit = (adUnitData) => ({
  code: `/${GPT_NETWORK_ID}/${adUnitData.name}`,
  mediaTypes: {
    banner: {
      sizes: adUnitData.sizes.filter((size) => Array.isArray(size)),
    },
  },
  ortb2Imp: {
    ext: {
      ae: 1,
    },
  },
  ...adUnitData.prebid,
});

export const generatePPID = (user = {}) => {
  const existingPPID = localStore.getItem('o-user-ppid');
  const isLoggedIn = user?.value?.email;
  if (isLoggedIn) {
    const userHash = SHA256.hash(user.value.email).toString();
    if (!existingPPID) {
      const newPPID = { value: userHash, type: 'user' };
      localStore.setItem('o-user-ppid', newPPID);
      return userHash;
    }

    if (existingPPID.type === 'anonymous') {
      const updatedPPID = { value: userHash, type: 'user' };
      localStore.setItem('o-user-ppid', updatedPPID);
      return userHash;
    }
    return existingPPID.value;
  }

  if (!existingPPID) {
    const anonHash = SHA256.hash(generateUniqueId()).toString();
    const anonPPID = { value: anonHash, type: 'anonymous' };
    localStore.setItem('o-user-ppid', anonPPID);
    return anonHash;
  }
  return existingPPID.value;
};
